<span class="filter-field-label">{{ label }}<span *ngIf="required" class="required-indicator">*</span></span>
<mat-form-field class="filter-field">
  <input matInput [attr.aria-label]="label" [formControl]="filterControl" [matAutocomplete]="auto" [placeholder]="placeholder" (blur)="onFreeTextBlur()">
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn.bind(this)" [requireSelection]="requireSelection"
    (optionSelected)="onOptionSelected($event.option.value)">
    <mat-option *ngFor="let option of filteredOptions$ | async; trackBy: trackByOptionId" [value]="option">
      {{ option.name }}
    </mat-option>
  </mat-autocomplete>
  <button type="button" mat-icon-button matSuffix (click)="onClear()" *ngIf="selectedValue && !disabled" matTooltip="Limpiar">
    <mat-icon>close</mat-icon>
  </button>
</mat-form-field>
